import { render } from "./ComplianceRepositories.vue?vue&type=template&id=2901830a&scoped=true"
import script from "./ComplianceRepositories.vue?vue&type=script&lang=js"
export * from "./ComplianceRepositories.vue?vue&type=script&lang=js"

import "./ComplianceRepositories.vue?vue&type=style&index=0&id=2901830a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2901830a"]])

export default __exports__